var React = require('react');

function CaretDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_151","data-name":"Path 151","d":"M1370,4190.176l5.729,5.729-5.729,5.729","transform":"translate(4203.047 -1368.586) rotate(90)","fill":"none","stroke":"#f9b233","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"}));
}

CaretDown.defaultProps = {"width":"24","height":"12","viewBox":"0 0 14.286 8.143"};

module.exports = CaretDown;

CaretDown.default = CaretDown;
